import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface FiscalYearsApiResponse {
  hasChildCompanies: boolean;
  fiscalYears: FiscalAllYearsResponse[]
}

export interface FiscalAllYearsResponse {
  companyId: number;
  companyName: string;
  startDate: string;
  endDate: string;
  content?: string;
  hasChildCompanies: boolean;
  usesInitialBudgets: boolean;
  activeGlCount: number;
  totalGlCount: number;
}
const useAllGetFiscalYearsApi = (companyId?: number, includeChildCompanies?: boolean) => {
  const call = useCallback(async () => {
    const res = await axiosInstance<FiscalYearsApiResponse>(api.getAllFiscalYears(), { params: { companyId, includeChildCompanies } });
    res.data.fiscalYears.sort((a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime())
    return res.data;
  }, [companyId, includeChildCompanies]);

  const { value: fiscalYears, execute, isLoading } = useAsync(call, false, undefined,{} as FiscalYearsApiResponse);
  return { fiscalYears, getFiscalYears: execute, isLoading };
};
export default useAllGetFiscalYearsApi;
